import {
  Warehouse, ArrowLeftRight, ClipboardCheck, Thermometer,
} from 'lucide-react';

export const DEFAULT_SITE_ID = 'site-celebration';

export const TABS = [
  {
    id: 'stock',
    label: 'Stock Levels',
    href: '/inventory/stock',
    icon: Warehouse,
  },
  {
    id: 'storage',
    label: 'Storage',
    href: '/inventory/storage',
    icon: Thermometer,
  },
  {
    id: 'transfers',
    label: 'Transfers',
    href: '/inventory/transfers',
    icon: ArrowLeftRight,
  },
  {
    id: 'counts',
    label: 'Cycle Counts',
    href: '/inventory/counts',
    icon: ClipboardCheck,
  },
];

export const ADJUSTMENT_TYPE_OPTIONS = [
  {
    value: 'add',
    label: 'Add Stock' 
  },
  {
    value: 'remove',
    label: 'Remove Stock' 
  },
  {
    value: 'set',
    label: 'Set Exact Quantity' 
  },
];

export const ADJUSTMENT_REASON_OPTIONS = [
  {
    value: 'count',
    label: 'Cycle Count Adjustment' 
  },
  {
    value: 'damage',
    label: 'Damaged Goods' 
  },
  {
    value: 'expired',
    label: 'Expired' 
  },
  {
    value: 'received',
    label: 'Received Delivery' 
  },
  {
    value: 'other',
    label: 'Other' 
  },
];

export const VENUE_OPTIONS = [
  {
    value: 'main-store',
    label: 'Main Store' 
  },
  {
    value: 'deck-9-pantry',
    label: 'Deck 9 Pantry' 
  },
  {
    value: 'bar-cooler',
    label: 'Bar Cooler' 
  },
];
